import { render, staticRenderFns } from "./histogram.vue?vue&type=template&id=5b6f2199&scoped=true&"
import script from "./histogram.vue?vue&type=script&lang=js&"
export * from "./histogram.vue?vue&type=script&lang=js&"
import style0 from "./histogram.vue?vue&type=style&index=0&id=5b6f2199&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f2199",
  null
  
)

export default component.exports